<template>
  <div class="ranking">
    <!-- 导航栏 -->
    <div class="header-top">
      <div class="header">
        <div :style="{ height: statusHeight + 'px' }"></div>
        <div class="nav-bar">
          <img @click="handelBack" src="@/assets/icon_back.png" alt="" />
          <div :class="['ranking-tab', language == 'ug' ? 'nav-title-ug' : 'nav-title']">
            <div class="nav-title-text-container" >
              <div :class="[ 'ranking-tab-item', activeTab === 0 && 'active' ]" @click="handleTab(0)">{{
                $t('魅力榜')
              }}</div>
              <div :class="[ 'ranking-tab-item', activeTab === 1 && 'active' ]" @click="handleTab(1)">{{
                $t('豪气榜')
              }}</div>
              <div :class="[ 'ranking-tab-item', activeTab === 2 && 'active' ]" @click="handleTab(2)">{{
                $t('游戏榜')
              }}</div>
            </div>
          </div>
          <div :class="[language == 'zh' && 'empty']"></div>
        </div>
      </div>
      <div class="ranking-top">
        <!-- <ScrollTabBar :list="barList" color="#C498FE" class="scroll_bar" :language="language" /> -->
        <div class="ranking-top-user">
          <div
            :class="['user', `number_${index + 1}`]"
            v-for="(item, index) in rankTop3"
            @click="goUserDetail(item)"
            :key="index"
          >
            <div class="user-img">
              <img :src="item.headUrl" alt="" />
              <div class="rank-user-part" v-if="item.headPendantUrl">
                <Pendant :url="item.headPendantUrl" />
              </div>
            </div>
            <p class="user_name text-ellipsis">{{ item.name }}</p>
          </div>
        </div>
        <div
          :class="[
            'ranking-top-bg',
            language == 'ug' && 'ranking-top-bg-ug ug',
            activeTab === 2 && 'ranking-top-bg-game'
          ]"
        >
          <div
            class="ranking-score"
            v-for="(item, index) in rankTop3"
            :key="index"
          >
            {{ $t(['魅力值', '豪气值', '赢得游戏币'][activeTab]) }}:{{ item.score }}
          </div>
          <div class="ranking_top_icon" v-if="activeTab === 2">
            <img src="@/assets/ranking/ranking_top1.webp" v-if="rankTop3.length >= 1" alt="" />
            <img src="@/assets/ranking/ranking_top2.webp" v-if="rankTop3.length >= 2" alt="" />
            <img src="@/assets/ranking/ranking_top3.webp" v-if="rankTop3.length >= 3" alt="" />
          </div>
          <div :class="['show_all_platform_btn', language === 'ug' && 'show_all_platform_btn_ug']" v-if="activeTab === 2">
            <div @click="showAllPaltform(1)" v-show="isShowAllsite(1)"><Lottie :src="getResourceJson" /></div>
            <div @click="showAllPaltform(0)" v-show="isShowAllsite(0)"><Lottie :src="getResourceJson" /></div>
            <div @click="showAllPaltform(2)" v-show="isShowAllsite(2)"><Lottie :src="getResourceJson" /></div>
          </div>
        </div>
      </div>
    </div>
    <div style="flex: 1; position: relative;">
      <div class="content">
        <div class="ranking-notice ug">
          <div class="notice-txt" @click="goToRules">
            <div
              :class="[language == 'ug' ? 'notice-left-ug ug' : 'notice-left']"
            >
              <img src="@/assets/ranking-notice.png" alt="" />
              <span class="custom-title">{{
                $t('实时更新排行榜,一周结算一次')
              }}</span>
            </div>
            <div style="display: flex;align-items: center;">
              <span
                :class="[
                  language == 'ug' ? 'notice-right-ug ug' : 'notice-right'
                ]"
                >{{ $t('排行榜规则') }}</span
              >
              <van-icon color="#9b9b9b" name="arrow" />
            </div>
          </div>
        </div>
        <div class="ranking_list_title">
          <p>{{ $t('排名') }}</p>
          <div class="flex justify-between flex-sub">
            <p>{{ $t('名称') }}</p>
            <p>{{ $t(['魅力值', '豪气值', '赢得游戏币'][activeTab]) }}</p>
          </div>
        </div>
        <div class="tab-ranking-list">
          <div
            :class="['ranking-item', `rank${index}`]"
            v-for="(item, index) in rankList"
            :key="index"
          >
            <div style="display: flex; flex: 1;" @click="goUserDetail(item)">
              <div class="rank-num flex-al-c">
                <span>{{ index + 4 }}</span>
              </div>
              <div class="rank-user">
                <div class="rank-user-avatar">
                  <img :src="item.headUrl" alt="" />
                  <div class="rank-user-part" v-if="item.headPendantUrl">
                    <Pendant :url="item.headPendantUrl" />
                  </div>
                </div>
                <div class="rank-user-info">
                  <div
                    :class="[
                      'rank-user-name',
                      'text-ellipsis',
                      language === 'ug' && 'ug-pt-2'
                    ]"
                  >
                    {{ item.name }}
                  </div>
                  <div
                    :class="[
                      'rank-user-sex',
                      item.sex == 2 ? 'rank-user-male' : 'rank-user-man'
                    ]"
                  >
                    <img
                      v-if="item.sex == 2"
                      src="../../assets/sex-male.png"
                      alt=""
                    />
                    <img v-else src="../../assets/sex-man.png" alt="" />
                    {{ resultAge(item.birthday) }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="harmonyOs_bold user_score"
              v-html="resultScenceScore(item)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 全平台展示弹窗 -->
    <van-dialog
      v-model="showAllPaltformDialog"
      :lazy-render="true"
      :showConfirmButton="false"
      :close-on-click-overlay="true"
      class="all_platform_dialog_container"
    >
      <div class="all_platform_dialog">
        <p :class="['tips_title', language]">{{ $t('提示') }}</p>
        <div class="tips_content">
          <p class="tips_text">
            {{
              $t(
                '升级至全平台展示后，其他用户xx天内可在直播资料卡、直播房间内、玩游戏等场景看到你的成就标识', { day: validDays }
              )
            }}
          </p>
          <van-swipe
            class="explame-imgs"
            :autoplay="2000"
            indicator-color="#B975FF"
            width="400" 
          >
            <van-swipe-item v-for="(image, index) in images" :key="index">
              <img class="explame-img" :src="image"/>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="tips_btn">
          <!-- <div @click="followAndJoin" :class="[language == 'ug' && 'div_ug']">
            {{ $t('关注并加入粉丝团xx', {amount: 1000}) }}
            <img src="@/assets/part-diamond.png" alt="" />
          </div> -->
          <div @click="followAndJoin" :class="[language]">
            {{ $t('立即展示至全平台') }}
            (<img src="@/assets/gameCoin/game-coin-icon.png" alt="" />{{ buyRankGameCoinNum }})
          </div>
          <div :class="[language]" @click="showAllPaltformDialog = false">{{ $t('取消') }}</div>
        </div>
      </div>
      <!-- <div :class="['all_platform_autoRenew', language == 'ug' && 'all_platform_autoRenew_ug']">
        <img @click="isAgreement = !isAgreement"
          :src="require(`../../assets/livevip/vip-agreement-${isAgreement ? 'select' : 'none'}.png`)"
          alt="">
        <p>{{ $t('到期后自动续购，标识到期前1天，平台将自动扣除费用，可随时取消') }}</p>
      </div> -->
    </van-dialog>
    <!-- 1、魅力榜 2、豪气榜 3、游戏榜 -->
    <ShareRinkDialog :isShow.sync="shareRinkDialogShow" :ranking="rankObj" /> 
  </div>
</template>

<script>
import { CommonModule } from '@/store/modules/common'
import { getGiftRanking, sendGiftRanking, gameWeekRanking, buyAllSiteShow, buyRankConfigQuery } from '@/api'
import {
  appFunc_callExit,
  appFunc_senToken,
  appFunc_GoUserInfo,
  appFunc_SaveData,
  appFunc_getSaveData
} from '@/utils/bridge'
import Pendant from '@/components/Pendant.vue'
// import ScrollTabBar from './components/ScrollTabBar.vue'
import ShareRinkDialog from './components/ShareRinkDialog.vue'
import Lottie from '@/components/Lottie.vue'
import Vue from 'vue'
import { Swipe, SwipeItem, Lazyload, Toast } from 'vant'
Vue.use(Lazyload)
  .use(Swipe)
  .use(SwipeItem)

export default {
  components: {
    Pendant,
    // ScrollTabBar,
    ShareRinkDialog,
    Lottie
  },
  data() {
    return {
      language: 'zh',
      statusHeight: 0,
      activeTab: 0,
      rankList: [],
      rankTop3: [],
      userId: '',
      perfixIcon: require('@/assets/gameCoin/game-coin-icon.png'),
      // barList: [
      //   { name: '日榜' },
      //   { name: '周榜' },
      //   { name: '月榜' }
      // ],
      showAllPaltformDialog: false,
      shareRinkDialogShow: false,
      images: [
        require('@/assets/ranking/1@2x.webp'),
        require('@/assets/ranking/2@2x.webp'),
        require('@/assets/ranking/3@2x.webp'),
        require('@/assets/ranking/4@2x.webp')
      ],
      isAgreement: 1,
      getGiftRanks: [],
      sendGiftRanks: [],
      gameRanks: [],
      rankingTop3AllList: [],
      rankObj: {},
      isNewSettlementTime: false, // 是否处于新的结算周期
      isSettlementTimeFirstEnter: '0', // 结算周期是否首次进入 1是 0否
      currentSettlementTime: '', // 当前结算周期时间
      buyRankGameCoinNum: 0,
      validDays: 0
      }
  },
  computed: {
    resultScenceScore() {
      return rank_info => {
        rank_info = rank_info || {}
        if (this.activeTab === 0) {
          return rank_info.score || 0
        } else if (this.activeTab === 1) {
          return rank_info.score || 0
        } else if (this.activeTab === 2) {
          return `<img style="width: 22px; height: 22px;margin-right: 4px;" class="perfix_gold_icon" src="${
            this.perfixIcon
          }" />${rank_info.score || 0}`
        }
      }
    },
    getResourceJson() {
      return `https://source.allosoft.top/h5/main/lottie/rank_btn_anim_${this.language}.json`
    }
  },
  watch: {
    activeTab: {
      async handler(val) {
        this.getRanking(val)
      }
    },
  },
  async created() {
    this.language = this.$route.query.language || 'ug'
    CommonModule.setLanguage(this.language)
    this.$i18n.locale = this.language
    this.statusHeight = this.$route.query.statusBarHeight || 0
    await this.getToken()
    this.getCountRanking()
    this.buyRankConfigQuery()
  },
  methods: {
    buyRankConfigQuery() {
      // 获取购买配置
      buyRankConfigQuery().then(res => {
        if (res.code == 1001) {
          this.buyRankGameCoinNum = res.data.gameCoinNum
          this.validDays = res.data.validDays
        }
      })
    },
    async getInitParams() {
        // 获取存储的结算时间
        const lastSettlementTime = await appFunc_getSaveData('settlementTime') || '2026-01-01'
        // const lastSettlementTime = '2026-01-01'
        // 获取结算周期是否是首次进入
        this.isSettlementTimeFirstEnter = await appFunc_getSaveData('isSettlementTimeFirstEnter') 
        // this.isSettlementTimeFirstEnter = ''
        // 是否处于新的结算周期
        this.isNewSettlementTime = new Date(this.currentSettlementTime).getTime() >= new Date(lastSettlementTime).getTime() + 7 * 24 * 3600000  
        // 处于新的结算周期
        if(this.isNewSettlementTime) {
          // 更新新的结算周期 & 是否首次进入的状态
          appFunc_SaveData('settlementTime', this.currentSettlementTime)
          appFunc_SaveData('isSettlementTimeFirstEnter', '1')
          this.isNewSettlementTime = true
          this.isSettlementTimeFirstEnter = '1'
          const userRanking = this.rankingTop3AllList?.filter(item => item.userId == this.userId)
          // 特殊处理同一用户处于多个榜单top3
          if(userRanking.length > 1)  userRanking.sort((a, b) => (a.ranking - b.ranking))
          this.rankObj = userRanking.length > 1 ? userRanking : userRanking[0]
          // 处于首次进入新的结算周期
          this.shareRinkDialogShow = this.isNewSettlementTime && this.isSettlementTimeFirstEnter === '1' && Boolean(this.rankObj)
        }else {
          // 处于旧的结算周期
          // 只更新是否首次进入的状态
          appFunc_SaveData('isSettlementTimeFirstEnter', '0')
        }
    },
    isShowAllsite(index) {
        return  this.rankTop3.length >= (index + 1) && (this.rankTop3[index]?.userId == this.userId)
    },
    async getCountRanking() {
      this.rankingTop3AllList = []
      const getDataEcho = async (api, key, type) => {
        return await api().then(res => {
          const { code, data } = res
          if (code === 1001 && data && data.length > 0) {
            this.currentSettlementTime = data[0]?.date
            // // 存一下首次进入结算周期
            this[key] = data
            for(let i = 0; i < 3; i++) data[i] && this.rankingTop3AllList.push({...data[i], type: type})
          }
        })
      }
      await getDataEcho(getGiftRanking, 'getGiftRanks', 0);
      this.getRanking()
      await getDataEcho(sendGiftRanking, 'sendGiftRanks', 1);
      await getDataEcho(gameWeekRanking, 'gameRanks', 2);
      this.getInitParams()
    },
    async getRanking(val) {
      this.rankList = []
      this.rankTop3 = []
      let data
      switch (val) {
        case 1:
          data = this.sendGiftRanks
          break;
        case 2:
          data = this.gameRanks
          break;
        default:
          data = this.getGiftRanks
          break;
      }
        if (data.length > 3) {
          this.rankTop3 = [
            ...data.slice(1, 2),
            ...data.slice(0, 1),
            ...data.slice(2, 3)
          ]
          this.rankList = data.slice(3)
        } else {
          this.rankTop3 = data
        }
    },
    async getToken() {
      const res = await appFunc_senToken()
      console.log(res, '/////////////')
      this.userId = res.id
    },
    handelBack() {
      appFunc_callExit()
    },
    resultUserRank(rank) {
      rank = Number(rank)
      switch (true) {
        case rank >= 1000:
          return '1000+'
        case rank >= 500:
          return '500+'
        case rank >= 100:
          return '100+'
        case rank >= 30:
          return '30+'
        default:
          return rank
      }
    },
    resultAge(birthday) {
      const birthdayTime = new Date(birthday).getTime()
      return Math.floor(
        (new Date().getTime() - birthdayTime) / 1000 / 60 / 60 / 24 / 365
      )
    },
    goUserDetail({ mobile }) {
      appFunc_GoUserInfo(JSON.stringify({ mobile }))
    },
    goToRules() {
      this.$router.push({
        path: '/rankingRules',
        query: {
          language: this.language,
          statusBarHeight: this.statusHeight
        }
      })
    },
    // 升级为全平台展示
    showAllPaltform(idx) {
      this.showAllSiteIndex = idx
      this.showAllPaltformDialog = true
    },
    // 关注并加入粉丝团
    followAndJoin() {
      const recomdId = this.rankTop3[this.showAllSiteIndex]?.id || 1647467
      if(!recomdId) return
      buyAllSiteShow(recomdId).then(res => {
        if (res.code == 1001) {
          Toast(this.$t('购买成功'))
        }else if (res.code == 11025) {
          // 游戏币不足
          this.$router.push({
            path: '/gameCoin',
            query: {
              language: this.language,
              statusBarHeight: this.statusHeight,
              isH5: true
            }
          })
        }
        else {
          Toast(res.message)
        }
        this.showAllPaltformDialog = false
      })
    },
    
    // 切换标签时，让当前标签显示完整，并且居中
    handleTab(val) {
      this.activeTab = val
      console.log(this.activeTab);
      
      this.$nextTick(() => {
        const tab = document.getElementsByClassName('ranking-tab')
        
        if(val === 0) {
          tab[0].scrollTo({
            left: 0,
            behavior: 'smooth'
          })
        }
        if(val === 2) {
          tab[0].scrollTo({
            left: tab[0].scrollWidth - tab[0].clientWidth,
            behavior: 'smooth'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ranking {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;

  .header-top {
    // display: flex;
    // flex-direction: column;
    // min-height: 398px;
    // justify-content: space-between;
    background: url('../../assets/ranking-bg.png') no-repeat;
    background-size: cover;
  }

  .ranking-top {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin: 0 12px 0 12px;
    padding-bottom: 30px;
    position: relative;

    .scroll_bar {
      position: absolute;
      top: 8px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 99;
    }

    .ranking-top-bg {
      display: flex;
      font-size: 12px;
      align-items: flex-end;
      justify-content: space-between;
      padding: 0 20px;
      height: 156px;
      background: url('../../assets/ranking-top-bg.png') no-repeat;
      background-size: cover;
      transform: translateY(-20px);
      position: relative;

      .ranking-score {
        color: #9d7899;
        padding-bottom: 15px;
      }
      .ranking_top_icon {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;

        img {
          position: absolute;
          width: 24px;
          height: 24px;
          &:nth-child(1) {
            top: -10px;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 23px;
            left: 15%;
            transform: translateX(-50%);
          }
          &:nth-child(3) {
            top: 23px;
            right: 15%;
            transform: translateX(50%);
          }
        }
      }
      .show_all_platform_btn {
        position: absolute;
        display: flex;
        width: 100%;
        height: 100%;
        left: 0;
        top: -20px;
        div {
          position: absolute;
          width: 98px;
          height: 22px;
          padding: 0 9px;
          font-weight: 400;
          font-size: 10px;
          color: #ffffff;
          text-align: center;
          line-height: 22px;
          border-radius: 14px;
          &:nth-child(1) {
            top: 17px;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 50px;
            left: 15%;
            transform: translateX(-50%);
          }
          &:nth-child(3) {
            top: 50px;
            right: 15%;
            transform: translateX(50%);
          }
        }
      }
      .show_all_platform_btn_ug {
        div {
          font-size: 6px !important;
        }
      }
    }
    .ranking-top-bg-game {
      padding: 0 10px;
    }

    .ranking-top-bg-ug {
      font-size: 8px;
      padding: 0 13px;
    }

    .ranking-top-user {
      display: flex;
      justify-content: space-between;
      height: 145px;
      padding: 0 25px;
      transform: translateY(16px);
      // padding-top: 30px;
      .user {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        text-align: center;
        padding-bottom: 15px;

        img {
          width: 60px;
          height: 60px;
        }

        .user_name {
          width: 60px;
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          padding-top: 5px;
        }
      }

      .user::after {
        content: '';
        display: block;
        width: 30px;
        height: 30px;
        // background-color: #F8BD32 ;
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
      }

      .number_2 {
        .user-img {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          width: 60px;
          height: 77px;
          background: url('../../assets/ranking-one-bg.png') no-repeat;
          background-size: contain;
          position: relative;

          img {
            width: 57px;
            height: 57px;
            border-radius: 50%;
            margin-bottom: 1.5px;
          }

          .rank-user-part {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 76px;
            height: 76px;
            transform: translate(-50%, -40%);
          }
        }
      }

      .number_1,
      .number_3 {
        align-self: flex-end;

        .user-img {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          width: 50px;
          height: 64px;
          background: url('../../assets/ranking-two-bg.png') no-repeat;
          background-size: cover;
          position: relative;

          img {
            width: 47px;
            height: 47px;
            margin-bottom: 1.5px;
            border-radius: 50%;
          }

          .rank-user-part {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -40%);
            width: 64px;
            height: 64px;
          }
        }
      }

      .number_3 {
        .user-img {
          background: url('../../assets/ranking-three-bg.png') no-repeat;
          background-size: cover;
        }
      }

      .number_three .user-img {
        background: url('../../assets/ranking-three-bg.png') no-repeat;
        background-size: cover;
      }
    }
  }

  .nav-bar {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    font-size: 14px;
    position: relative;

    img,
    .empty {
      width: 30px;
      height: 30px;
    }

    .nav-title {
      flex: 1;
      font-size: 18px;
      height: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 400;
      font-size: 18px;
      color: #5c5c5c;

      div {
        margin: 0 20px;
      }

      .active {
        position: relative;
        font-weight: 500;
        color: #333333;
      }

      .active::after {
        content: '';
        display: block;
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
        width: 29px;
        height: 6px;
        background: linear-gradient( 90deg, #B975FF 0%, rgba(185,117,255,0) 100%);
        border-radius: 50px;
      }
    }

    .nav-title-text-container {
      display: flex;
      width: fit-content;
      white-space: nowrap;
    }

    .nav-title-ug {
      flex: 1;
      display: flex;
      height: 30px;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: 'UKIJCJK';
      font-weight: 400;
      overflow-x: scroll;
      color: #5c5c5c;
      &::-webkit-scrollbar {
        display: none;
      }

      div:nth-child(2) {
        margin: 0 12px;
      }

      .active {
        position: relative;
        font-weight: 500;
        color: #333333;
      }

      .active::after {
        content: '';
        display: block;
        position: absolute;
        bottom: -3px;
        left: 50%;
        transform: translateX(-50%);
        width: 70%;
        height: 6px;
        background: linear-gradient( 90deg, #B975FF 0%, rgba(185,117,255,0) 100%);
        border-radius: 50px;
      }
    }
  }
}

.content {
  width: 100%;
  height: calc(100% + 40px);
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #ffffff;
  border-radius: 20px 20px 0 0;
  overflow: hidden;
  position: absolute;
  top: -50px;
  left: 0;
  box-sizing: border-box;

  .ranking-notice {
    img {
      width: 16px;
      height: 16px;
      margin-right: 2px;
    }

    .notice-txt {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 14px;
    }

    .notice-left {
      width: 250px;
      display: flex;
      align-items: center;

      .custom-title {
        font-size: 14px;
        color: #5c5c5c;
      }
    }

    .notice-right {
      font-size: 12px;
      color: #999999;
    }

    .notice-left-ug {
      width: auto;
      padding-right: 3px;
      display: flex;
      align-items: center;

      .custom-title {
        font-size: 12px;
        color: #5c5c5c;
      }
    }

    .notice-right-ug {
      font-size: 9px;
      color: #999999;
    }
  }

  .ranking_list_title {
    display: flex;
    width: 100%;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    text-align: left;
    padding: 0 14px 4px;
    box-sizing: border-box;
    p:nth-child(1) {
      width: 90px;
      margin-right: 13px;
    }
    p:nth-child(3) {
      text-align: right;
    }
  }

  .tab-ranking-list {
    flex: 1;
    overflow-y: scroll;
    // padding-bottom: 20px;
    padding-bottom: constant(safe-area-inset-bottom);
    /* 兼容 iOS<11.2 */
    padding-bottom: env(safe-area-inset-bottom);
    /* 兼容iOS>= 11.2 */

    .ranking-item {
      display: flex;
      justify-content: space-between;
      padding: 12px 14px;

      .rank-num {
        padding-right: 14px;
        margin-right: 7px;
        box-sizing: border-box;
        font-family: HarmonyOS Sans, HarmonyOS Sans;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        width: 42px;
        justify-content: center;
      }

      .rank-user {
        display: flex;

        .rank-user-avatar {
          display: flex;
          align-items: center;
          margin-right: 8px;
          position: relative;

          img {
            width: 42px;
            height: 42px;
            border-radius: 50%;
          }
        }

        .rank-user-part {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 60px;
          height: 60px;
        }

        .rank-user-info {
          width: 140px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding-left: 4px;

          .rank-user-name {
            width: 163px;
            font-weight: 500;
            font-size: 16px;
            color: #181818;
          }

          .rank-user-sex {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 38px;
            height: 18px;
            border-radius: 17px;
            font-weight: 400;
            font-size: 10px;

            img {
              width: 14px;
              height: 14px;
            }
          }

          .rank-user-male {
            background: #ffe3e9;
            color: #F3A5FF;
          }

          .rank-user-man {
            background: #cfe2ff;
            color: #64C5F9;
          }
        }

        .user-position {
          width: 24px;
          padding-left: 10px;

          img {
            width: 24px;
            height: 24px;
          }
        }
      }

      .user_score {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        text-align: left;
      }
    }
  }

  .user-rank {
    display: flex;
    align-items: center;
    height: 72px;
    background: #ffffff;
    box-shadow: 0px -4px 12px 0px rgba(0, 0, 0, 0.06);
    border-radius: 20px 20px 0px 0px;
    padding: 0 62px;

    .rank {
      width: 42px;
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      color: #e93125;
      padding-right: 3px;
    }

    .user-avatar {
      padding: 0 4px;
      margin-right: 8px;

      img {
        width: 42px;
        height: 42px;
        border-radius: 12px;
      }
    }

    .user-name {
      font-weight: 500;
      font-size: 16px;
      color: #181818;
    }
  }

  .flex-al-c {
    display: flex;
    align-items: center;
  }
}

::v-deep .van-cell {
  padding: 18px 14px;
}

.all_platform_dialog {
  padding: 20px 28px;
  .tips_title {
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    text-align: center;
  }
  .tips_content {
    .tips_text {
      font-weight: 400;
      font-size: 14px;
      color: #5c5c5c;
      text-align: center;
      line-height: 18px;
      padding: 10px 0 12px;
    }
    .explame-imgs {
      width: 265px;
      height: 130px;
      padding-bottom: 30px;
      box-sizing: border-box;
      border-radius: 5px;
      .explame-img {
        width: 265px;
        border-radius: 5px;
      }
    }
  }
  .tips_btn {
    padding-top: 10px;
    div {
      width: 100%;
      height: 44px;
      line-height: 36px;
      text-align: center;
      border-radius: 23px;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      background: #C498FE;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 20px;
        height: 20px;
      }
      &:nth-child(2) {
        background: #f3f4f6;
        margin-top: 8px;
        color: #999999;
      }
    }
  }
}

::v-deep .all_platform_dialog_container {
  overflow: initial !important;
}

::v-deep .all_platform_autoRenew {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: -45px;
  font-size: 12px;
  color: #FFFFFF ; 
  text-align: center;
  padding: 0 43px;
  font-size: 12px;
  line-height: 16px;
  color: rgba(255, 255, 255, .6); 
  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}

::v-deep .all_platform_autoRenew_ug {
  bottom: -70px;
}

::v-deep .van-swipe__indicator {
  width: 6px;
  height: 6px;
  background: rgba(185, 117, 255, 0.2);
}
</style>
